import React, { useState, useEffect } from 'react';
import { usePage, router } from '@inertiajs/react';

export default function AuthLayout({ children }) {
  const { flash } = usePage().props;
  const [localFlash, setLocalFlash] = useState(flash || {});
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    setLocalFlash(flash || {});
  }, [flash]);

  useEffect(() => {
    const startHandler = () => setNavigating(true);
    const endHandler = () => setNavigating(false);
    router.on('start', startHandler);
    router.on('finish', endHandler);
    return () => {
      router.on('start', startHandler);
      router.on('finish', endHandler);
    };
  }, []);

  return (
    <div className="h-full bg-white">
      {navigating && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-white/60">
          <svg className="h-8 w-8 animate-spin text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
      )}
      {localFlash?.alert && (
        <div className="mb-4 bg-red-500 px-4 py-3 text-white text-center font-semibold shadow-sm cursor-pointer" onClick={() => setLocalFlash(f => ({ ...f, alert: null }))}>
          {localFlash.alert}
        </div>
      )}
      {localFlash?.notice && (
        <div className="mb-4 bg-green-500 px-4 py-3 text-white text-center font-semibold shadow-sm cursor-pointer" onClick={() => setLocalFlash(f => ({ ...f, notice: null }))}>
          {localFlash.notice}
        </div>
      )}
      <main>
        {children}
      </main>
    </div>
  );
}
